import { gql } from "@apollo/client";

export const CREATE_WAREHOUSE = gql`
  mutation CreateWarehouseMutation($input: CreateWarehouseInput!) {
    createWarehouse(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_WAREHOUSE = gql`
  mutation UpdateWarehouseMutation($id: Int!, $input: UpdateWarehouseInput!) {
    updateWarehouse(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_WAREHOUSE = gql`
  mutation RemoveWarehouseMutation($id: Int!) {
    removeWarehouse(id: $id) {
      ok
      error
    }
  }
`;

export const WAREHOUSE = gql`
  query WarehouseQuery($id: Int!) {
    warehouse(id: $id) {
      ok
      error
      result {
        id
        name
        address
        active
      }
    }
  }
`;

export const WAREHOUSES = gql`
  query WarehousesQuery($where: WarehousesFiltersInput!) {
    warehouses(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        name
        address
        active
      }
    }
  }
`;
